var installedModules = {};
var moduleToHandlerMapping = {
	45718: {
		getter: function() { return __webpack_require__.e(5893).then(function() { return function() { return __webpack_require__(85893); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^18.2.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react/jsx-runtime",
	},
	86122: {
		getter: function() { return __webpack_require__.e(7294).then(function() { return function() { return __webpack_require__(67294); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react",
	},
	56878: {
		getter: function() { return __webpack_require__.e(9265).then(function() { return function() { return __webpack_require__(20745); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-dom/client",
	},
	55676: {
		getter: function() { return __webpack_require__.e(3935).then(function() { return function() { return __webpack_require__(73935); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-dom",
	},
	82504: {
		getter: function() { return __webpack_require__.e(5378).then(function() { return function() { return __webpack_require__(9008); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^14.1.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/head",
	},
	42598: {
		getter: function() { return __webpack_require__.e(9583).then(function() { return function() { return __webpack_require__(11163); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/router",
	},
	52679: {
		getter: function() { return __webpack_require__.e(3314).then(function() { return function() { return __webpack_require__(4298); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^14.1.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/script",
	},
	27086: {
		getter: function() { return __webpack_require__.e(5893).then(function() { return function() { return __webpack_require__(85893); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react/jsx-runtime",
	},
	31030: {
		getter: function() { return __webpack_require__.e(5893).then(function() { return function() { return __webpack_require__(85893); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^17.0.0 || ^18.0.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react/jsx-runtime",
	},
	7860: {
		getter: function() { return __webpack_require__.e(8010).then(function() { return function() { return __webpack_require__(41664); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^14.1.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/link",
	},
	67042: {
		getter: function() { return __webpack_require__.e(5893).then(function() { return function() { return __webpack_require__(85893); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^18.3 || >=19.0.0-rc",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react/jsx-runtime",
	},
	7164: {
		getter: function() { return __webpack_require__.e(5893).then(function() { return function() { return __webpack_require__(85893); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^17 || ^18",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react/jsx-runtime",
	},
	9029: {
		getter: function() { return __webpack_require__.e(334).then(function() { return function() { return __webpack_require__(4298); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^12 || ^13 || ^14",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/script",
	},
	13752: {
		getter: function() { return __webpack_require__.e(9260).then(function() { return function() { return __webpack_require__(25675); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^12 || ^13 || ^14",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/image",
	},
	14825: {
		getter: function() { return __webpack_require__.e(6405).then(function() { return function() { return __webpack_require__(64254); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^5.1.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "styled-jsx/style",
	},
	37251: {
		getter: function() { return __webpack_require__.e(5063).then(function() { return function() { return __webpack_require__(41664); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^12 || ^13 || ^14",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/link",
	},
	44196: {
		getter: function() { return __webpack_require__.e(9008).then(function() { return function() { return __webpack_require__(9008); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^12 || ^13 || ^14",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/head",
	},
	77514: {
		getter: function() { return __webpack_require__.e(8860).then(function() { return function() { return __webpack_require__(5152); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^12 || ^13 || ^14",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/dynamic",
	},
	92357: {
		getter: function() { return __webpack_require__.e(3223).then(function() { return function() { return __webpack_require__(15015); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^5.1.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "styled-jsx",
	},
	7126: {
		getter: function() { return __webpack_require__.e(5893).then(function() { return function() { return __webpack_require__(85893); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^16.8.0 || ^17.0.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react/jsx-runtime",
	},
	63912: {
		getter: function() { return __webpack_require__.e(8860).then(function() { return function() { return __webpack_require__(5152); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^14.1.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/dynamic",
	}
};
var initialConsumes = [45718,86122,56878,55676,82504,42598,52679,27086,31030,7860,67042,7126,7126,7126,63912,7126,7126,7126,63912,7126,7126,63912,63912,7126,63912,7126,63912,7126,63912,7126,7126,63912,7126,7126,7126,63912,7126,63912,7126,7126,63912,7126];
__webpack_require__.federation.installInitialConsumes= ()=>__webpack_require__.federation.bundlerRuntime.installInitialConsumes({initialConsumes, installedModules, moduleToHandlerMapping, webpackRequire:__webpack_require__});
var chunkMapping = {
	"179": [
		45718,
		86122,
		56878,
		55676
	],
	"334": [
		55676
	],
	"745": [
		55676
	],
	"1055": [
		7126
	],
	"1163": [
		45718,
		55676,
		86122
	],
	"1252": [
		7126
	],
	"1664": [
		45718,
		86122
	],
	"1929": [
		63912,
		7126
	],
	"1960": [
		7126
	],
	"2099": [
		7126
	],
	"2197": [
		7126
	],
	"2397": [
		7126
	],
	"2607": [
		7126
	],
	"2888": [
		82504,
		42598,
		52679,
		27086,
		31030,
		7860,
		67042
	],
	"3128": [
		63912,
		7126
	],
	"3738": [
		7164,
		9029,
		13752,
		14825,
		37251,
		42598,
		44196,
		45718,
		77514,
		86122,
		92357
	],
	"3935": [
		86122
	],
	"4076": [
		63912
	],
	"4254": [
		86122
	],
	"4298": [
		45718,
		55676,
		86122
	],
	"4352": [
		7126
	],
	"4820": [
		7126
	],
	"5015": [
		86122
	],
	"5152": [
		45718,
		86122
	],
	"5405": [
		63912,
		7126
	],
	"5675": [
		45718,
		55676,
		86122
	],
	"5815": [
		7126,
		63912
	],
	"5820": [
		7126,
		63912
	],
	"6194": [
		63912,
		7126
	],
	"7581": [
		7126
	],
	"8255": [
		7126,
		63912
	],
	"8335": [
		7126,
		63912
	],
	"8521": [
		86122
	],
	"8978": [
		7126,
		63912
	],
	"9158": [
		63912,
		7126
	],
	"9195": [
		7126
	],
	"9260": [
		55676
	],
	"9527": [
		45718,
		86122
	],
	"9583": [
		55676
	]
};
__webpack_require__.f.consumes = function(chunkId, promises) {
	__webpack_require__.federation.bundlerRuntime.consumes({chunkMapping, installedModules, chunkId, moduleToHandlerMapping, promises, webpackRequire:__webpack_require__});
}